export enum WidgetPosition {
  BottomLeft,
  BottomRight,
  MiddleLeft,
  MiddleRight,
}
